import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ErrorDetailRuleComponent} from "../error-detail-rule/error-detail-rule.component";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
    IonButton,
    IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol,
    IonGrid, IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader, IonRow,
    IonSelect,
    IonSelectOption, IonText, IonSpinner
} from "@ionic/angular/standalone";
import {TranslatePipe} from "@ngx-translate/core";
import {BaseError} from '../../../models/error/BaseError';
import {ErrorPriority} from '../../../enums/ErrorPriority';
import {CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport} from '@angular/cdk/scrolling';

@Component({
    selector: 'app-error-detail-table-record-template',
    templateUrl: './error-detail-table-record-template.component.html',
    styleUrls: ['./error-detail-table-record-template.component.css'],
    standalone: true,
    imports: [
        ErrorDetailRuleComponent,
        FormsModule,
        IonGrid,
        IonSelect,
        IonSelectOption,
        ReactiveFormsModule,
        TranslatePipe,
        CdkFixedSizeVirtualScroll,
        CdkVirtualForOf,
        CdkVirtualScrollViewport,
        IonItem,
        IonList,
        IonListHeader,
        IonLabel,
        IonText,
        IonCard,
        IonCardContent,
        IonCardHeader,
        IonCardTitle,
        IonIcon,
        IonButton,
        IonRow,
        IonCol,
        IonSpinner
    ]
})
export class ErrorDetailTableRecordTemplateComponent  implements OnInit {
    @Input({required: true}) loadingErrorData!: boolean;
    @Input({required: true}) isSolvingError!: boolean;
    @Input({required: true}) error?: BaseError;
    @Output() errorTypeUpdated = new EventEmitter<ErrorPriority>();
    @Output() errorSolved = new EventEmitter<void>();

    public errorTypes: { value: string, translationKey: string }[] = [
        {value: "error", translationKey: "error.type.error"},
        {value: "warning", translationKey: "error.type.warning"},
        {value: "information", translationKey: "error.type.information"}
    ];

    public detailForm = new FormGroup({
        errorType: new FormControl<string>(this.errorTypes[0].value, {nonNullable: true})
    });

    public ngOnInit() {
        this.updateDetailForm();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes["error"]) {
            this.updateDetailForm();
        }
    }

    private updateDetailForm() {
        if (this.error) {
            this.detailForm.patchValue({
                errorType: this.error.errorPriority
            }); 
        }
    }

    public changeErrorType() {
        const values = this.detailForm.getRawValue();
        this.errorTypeUpdated.emit(values.errorType as ErrorPriority);
    }

    public onSolveErrorClick() {
        this.errorSolved.emit();
    }
}
